<template>
  <v-select
      :value="value"
      :options="availablePaymentMethods"
      :reduce="(item) => item.type"
      :filterable="false"
      :clearable="false"
      :searchable="false"
      :disabled="disabled || (!isAdmin && (isLoadingBank || !resolvedContractType))"
      label="name"
      placeholder="Select payment method"
      class="new-select"
      @input="$emit('input', $event)"
  >
    <template #open-indicator>
      <svg
          xmlns="http://www.w3.org/2000/svg"
          width="8"
          height="5"
          viewBox="0 0 8 5"
          fill="none">
        <path
            d="M7.872.418 7.61.138a.423.423 0 0 0-.619 0l-2.99 3.164L1.01.135a.422.422 0 0 0-.619 0L.128.413a.483.483 0 0 0 0 .655L3.691 4.85a.437.437 0 0 0 .31.149h.002a.437.437 0 0 0 .31-.149l3.56-3.773A.482.482 0 0 0 8 .747a.477.477 0 0 0-.128-.33Z"
            fill="#606060" />
      </svg>
    </template>
    <template #option="option">
      <div class="select__item d-center">
        {{ option.name }}
      </div>
    </template>
    <template #selected-option="option">
      <div class="selected d-center">
        {{ option.name }}
      </div>
    </template>
  </v-select>
</template>

<script>
import apiBanks from '@/services/api.banks'
import {getPaymentMethodsByContractType} from '@/common/helpers/paymentMethods'

export default {
  name: 'AtPaymentMethodSelect',
  props: {
    value: {
      default: null,
    },
    bankId: {
      type: [Number, String],
      default: null,
    },
    contractType: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isAdmin: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loadedContractType: null,
      isLoadingBank: false,
      bankRequestId: 0,
    }
  },
  computed: {
    resolvedContractType() {
      return this.contractType || this.loadedContractType
    },
    availablePaymentMethods() {
      return getPaymentMethodsByContractType(this.resolvedContractType, this.isAdmin)
    },
  },
  watch: {
    value() {
      if (this.isAdmin || this.resolvedContractType) {
        this.resetUnavailableValue()
      }
    },
    bankId() {
      this.resolveContractType()
    },
    contractType() {
      this.resolveContractType()
    },
    isAdmin() {
      this.resolveContractType()
    },
    resolvedContractType(contractType) {
      if (this.isAdmin || contractType) {
        this.resetUnavailableValue()
      }
    },
  },
  created() {
    this.resolveContractType()
  },
  beforeDestroy() {
    this.bankRequestId += 1
  },
  methods: {
    resolveContractType() {
      const requestId = ++this.bankRequestId

      if (this.isAdmin) {
        this.loadedContractType = null
        this.isLoadingBank = false
        this.resetUnavailableValue()
        return
      }

      if (this.contractType) {
        this.loadedContractType = null
        this.isLoadingBank = false
        this.resetUnavailableValue()
        return
      }

      if (this.bankId === null || this.bankId === undefined || this.bankId === '') {
        this.loadedContractType = null
        this.isLoadingBank = false
        return
      }

      this.isLoadingBank = true
      apiBanks.getBank(this.bankId)
          .then((response) => {
            if (requestId !== this.bankRequestId) return
            this.loadedContractType = response.data && response.data.contractType
            this.isLoadingBank = false
          })
          .catch((error) => {
            if (requestId !== this.bankRequestId) return
            this.loadedContractType = null
            this.isLoadingBank = false
            this.$emit('bank-load-error', error)
          })
    },
    resetUnavailableValue() {
      if (this.value === null || this.value === '') return

      const isAvailable = this.availablePaymentMethods.some((method) => method.type === this.value)
      if (!isAvailable) {
        this.$emit('input', null)
      }
    },
  },
}
</script>
